import { render, staticRenderFns } from "./GovLogo.vue?vue&type=template&id=0c02737e&scoped=true"
import script from "./GovLogo.vue?vue&type=script&lang=js"
export * from "./GovLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c02737e",
  null
  
)

export default component.exports